import React from 'react'

import './footer.css'
import logo from '../../assets/images/lsk_white.png'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <div className='lsk__footer section__padding'>
      <div className='lsk__footer-links'>
        <div className='lsk__footer-links_logo'>
          <img src={logo} alt='logo' />
          <p>Av. Engenheiro Luís Carlos Berrini, 1748</p>
          <p>Conjunto 1710 - Cidade Monções </p>
          <p>São Paulo/SP</p>
          <br></br>
          <p>Todos os Direitos Reservados</p>
        </div>
        <div className='lsk__footer-links_div'>
          <h4>Links</h4>
          <p>Home</p>
          <p>Quem Somos</p>
          <p>Nossas Soluções</p>
          <p>Nosso Trabalho</p>
          <p>Blog</p>
          <p>Trabalhe Conosco</p>
        </div>
        <div className='lsk__footer-links_div'>
          <h4>Empresa</h4>
          <p>Termos e Condições</p>
          <p>Política de Privacidade</p>
          <p>Contato</p>
        </div>
        <div className='lsk__footer-links_div'>
          <h4>Entre em contato</h4>
          <p>Av. Engenheiro Luís Carlos Berrini, 1748</p>
          <p>Conjunto 1710 - Cidade Monções </p>
          <p>São Paulo/SP</p>
          <p>+55-11-93287-8255</p>
          <p>info@lisko.com.br</p>
          <div className='lsk__footer-links-icons'>
            <FontAwesomeIcon icon={faFacebook} />
            <FontAwesomeIcon icon={faInstagram} />
            <FontAwesomeIcon icon={faLinkedin} />
              <i className="fa-solid fa-user"></i>
              <i className="fa-solid fa-user"></i>
          </div>
        </div>
      </div>
      <div className='lsk__footer-copyright'>
        <p>© 2023 LISKO. Todos os Direitos Reservados.</p>
      </div>
    </div>
  )
}

export default Footer